import Box from '@mui/material/Box'
import React from 'react'

const Flex = ({ children, ...rest }) => (
  <Box
    {...rest}
    sx={[
      { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' },
      ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
    ]}
  >
    {children}
  </Box>
)

export default Flex
